// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { footerContainerStyles } from "@synd/Overrides/Widgets/Footer/FooterContainer";
import { DivWrapper } from "@synd/XDL/constants";
import { color, layoutContainer, xScreen } from "@synd/XDL/Utilities";
import { css } from "styled-components";

footerContainerStyles.widgetGridContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 24px;
    `,
};

footerContainerStyles.footerBottomSection = {
    css: css`
        ${({ simpleFooter }: any) =>
            !simpleFooter &&
            css`
                background-color: ${color("common.ui8")};
            `}
    `,
};

footerContainerStyles.linksAndCopyRightContainer = {
    css: css`
        display: grid;
        grid-template-columns: repeat(5, 1fr);
        column-gap: 78px;
        row-gap: 24px;
        ${layoutContainer}
        ${({ simpleFooter }: any) =>
            !simpleFooter &&
            css`
                padding-top: 24px;
            `}

        ${xScreen("lte", "md")} {
            grid-template-columns: repeat(2, 1fr);
            column-gap: 20px;
        }
        ${xScreen("lt", "sm")} {
            column-gap: 24px;
        }
    `,
};

footerContainerStyles.siteMapLinksGridItem = {
    css: css`
        grid-column: 1 / 6;
        display: flex;
        justify-content: space-between;
        padding-top: 12px;
        padding-bottom: 16px;
        border-top: 1px solid ${color("common.border")};
        & > ${DivWrapper} {
            display: flex;
            align-items: center;
        }
        & > ${DivWrapper}:nth-child(2) {
            justify-content: flex-end;
        }

        ${xScreen("lte", "md")} {
            grid-column: 1 / 3;
        }
        ${xScreen("lt", "sm")} {
            flex-direction: column;
            row-gap: 12px;
            & > ${DivWrapper}:nth-child(2) {
                justify-content: flex-start;
            }
        }
    `,
};

footerContainerStyles.socialLinksGridItem = {
    css: css`
        display: flex;
        flex-direction: column;
        row-gap: 24px;
        & > div {
            flex: 1;
        }
        ${xScreen("lte", "md")} {
            column-gap: 20px;
            flex-direction: row;
            grid-column: 1 / 3;
        }
        ${xScreen("lt", "sm")} {
            flex-direction: column;
        }
    `,
};
